export default {
  translation: {
    nav: {
      home: '홈',
      trips: '여행',
      aboutUs: '회사 소개',
      alerts: '알림',
      wishlist: '위시리스트',
      language: '언어',
      profile: '프로필',
      settings: '설정',
      signIn: '로그인',
      signUp: '회원가입'
    },
    hero: {
      title: '우간다 탐험',
      subtitle: '그리고 그 너머',
      description: '전문 현지 가이드와 함께 아프리카의 진주를 발견하세요. 우간다의 숨막히는 풍경과 활기찬 문화에서 잊을 수 없는 경험이 여러분을 기다립니다.',
      searchPlaceholder: '어디로 가시나요?',
      categories: {
        all: '전체',
        wildlife: '야생동물',
        safari: '사파리',
        cultural: '문화',
        adventure: '모험',
        birding: '조류 관찰'
      }
    },
    common: {
      from: '부터',
      reviews: '리뷰',
      viewMore: '더 보기',
      book: '예약',
      seeAll: '전체 보기',
      loading: '로딩 중...'
    }
  }
};